module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921094151_T.d4903ee3.jpg";